import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, EmptyState } from '@feathr/components';
import Page from '@feathr/extender/App/Page';
import { useLocalUrl } from '@feathr/extender/state';

function DataExportsPage(): JSX.Element {
  const { t } = useTranslation();
  const localUrl = useLocalUrl();

  return (
    <Page
      collapseHeader={false}
      collapseHeaderOnScroll={true}
      description={t(
        'View export progress, download completed files, and manage past exports. Exports are started from the Groups page.',
      )}
      title={t('Exports')}
    >
      <EmptyState
        description={t('Export one to get started.')}
        height={'full'}
        label={t('No exports found.')}
        name={'data-exports-empty-state'}
        theme={'white'}
        width={'full'}
      >
        <Button link={localUrl('/data/segments')} type={'primary'}>
          {t('Go to Groups')}
        </Button>
      </EmptyState>
    </Page>
  );
}

export default DataExportsPage;
